import BaseObjectStore from './base-object.store';
import { makeObservable, observable, action } from 'mobx';
import axiosBarwisInstance from 'libs/axios/axios.lib';
import userStore from './user.store';

class ArsSummaryReportStore extends BaseObjectStore {
  currentTab = 'weakness';
  currentComparisonSide = null;
  tracingAllowed = false;
  constructor(props) {
    super(props);
    makeObservable(this, {
      currentTab: observable,
      setCurrentTab: action,
      currentComparisonSide: observable,
      setCurrentComparisonSide: action,
      tracingAllowed: observable,
      setTracingAllowed: action,
    });
    this.name = 'arsSummaryReport';
  }

  setCurrentTab(tab) {
    this.currentTab = tab;
  }

  getCurrentTab() {
    return this.currentTab;
  }

  setCurrentComparisonSide(side) {
    this.currentComparisonSide = side;
  }

  getCurrentComparisonSide() {
    return this.currentComparisonSide;
  }

  setTracingAllowed(tracingAllowed) {
    this.tracingAllowed = tracingAllowed;
  }

  getTracingAllowed() {
    return this.tracingAllowed;
  }

  async getIsTracingAllowed() {
    const user = userStore.getUser();
    try {
      this.setIsLoading(true);
      const response = await axiosBarwisInstance.get('/api/options/ARS_SUMMARY_REPORT_TRACING_IDS');
      if (response.status === 200) {
        const tracingConfig = JSON.parse(response.data.config);
        if (tracingConfig.includes(+user.id)) {
          this.setTracingAllowed(true);
        } else {
          this.setTracingAllowed(false);
        }
      } else {
        throw new Error('Error fetching data');
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setIsLoading(false);
    }
  }

  getScoreColor(score) {
    //Dark Green = A = 90-100, Light Green = B = 80-89, Yellow = C = 70-79,Orange = D = 60-69,Red = F = <59
    if (score === null || score === undefined || isNaN(score)) {
      return 'transparent';
    }

    if (score >= 90) {
      return '#00AF3F';
    } else if (score >= 80 && score < 90) {
      return '#00AF3F';
    } else if (score >= 70 && score < 80) {
      return '#FFD700';
    } else if (score >= 60 && score < 70) {
      return '#FF6E00';
    } else {
      return '#FF0000';
    }
  }

  resetAllFields() {
    this.resetAllBaseFields();
    this.setCurrentTab('weakness');
    this.setCurrentComparisonSide(null);
    this.setTracingAllowed(false);
  }
}

export default new ArsSummaryReportStore();
